import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components/macro';
import { WorkListTable } from './Components/WorkListTable';
import { WorkListSearch } from './Components/WorkListSearch';
import { selectAccessRight, selectHistoryDate, selectWorklistData } from './slice/selectors';
import { useSelector } from 'react-redux';
import { LinearProgress } from '@mui/material';
import useWindowDimensions from '../../components/useWindowDimensions';
import ErrorDialog from '../../components/ErrorDialog';
import BarAndMenu from '../../components/BarAndMenu';
import { translations } from '../../../locales/translations';
import { useTranslation } from 'react-i18next';

export function WorkListPage() {
  const { t } = useTranslation();
  const workListItems = useSelector(selectWorklistData);
  const accessright = useSelector(selectAccessRight);
  const historyDate = useSelector(selectHistoryDate);
  const { width } = useWindowDimensions();
  const [loading, setLoading] = useState<boolean>(false);
  const tableMinWidth = accessright.edit? 1510 : 1000;

  return (
    <Wrapper>
      <BarAndMenu />
      <div className={`worklist-container ${width < tableMinWidth ? 'full-window' : accessright.edit? 'large-center-window' : 'small-center-window'}`}>
        <WorkListSearch initialLoad={!workListItems} setTableLoading={setLoading} />
        <div className={'no-history-reminder'}>
          {t(translations.noHistoryReminder).replace('{historyDate}', historyDate)}
        </div>
        {!workListItems || loading ? (
          <LinearProgress />
        ) : (
          <WorkListTable workListItems={workListItems} />
        )}
        <ErrorDialog />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  margin-left: -300px; //left drawer width

  .worklist-container {
    padding: 10px;
    
    .no-history-reminder {
      text-align: end;
    }
  }

  .full-window {
    width: 100%;
  }

  .large-center-window {
    width: 1510px;
  }
  
  .small-center-window {
    width: 880px;
  }
`;
